import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import AccordionSection from '../AccordionSection/AccordionSection';
import './Accordion.less';

/**
 * Class representing an Accordion
 * @extends Component
 */
const Accordion = ({ parent, activeKey, openSections, handleLabelClick }) => {
  const parentKey = parent.key || parent.id;
  const parentClassname = cx('category-tree__title', {
    'is-active': activeKey && activeKey === parentKey,
  });

  return (
    <>
      <p className="category-tree__link" onClick={handleLabelClick(parent)}>
        <span className={parentClassname}>{parent.name}</span>
      </p>
      <div className="facet-options accordion">
        {parent.children.map((category, index) => (
          <AccordionSection
            key={index}
            onLabelClick={handleLabelClick}
            activeKey={activeKey}
            category={category}
            openSections={openSections}
          />
        ))}
      </div>
    </>
  );
};

Accordion.propTypes = {
  activeKey: PropTypes.string,
  parent: PropTypes.shape({
    id: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        key: PropTypes.string,
        name: PropTypes.string,
      })
    ),
  }),
  handleLabelClick: PropTypes.func,
  openSections: PropTypes.shape({}),
};

export default Accordion;
